import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
    const store = usePreviousRouteStore();

    nuxtApp.$router.beforeEach((to, from, next) => {
        if (from.path !== to.path) {
            store.set(from.fullPath);
        }
        next();
    });
});
